var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#df1e35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc162c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v3.809524h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.619048h16v3.809524h-16z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.809524h16v3.809524h-16z",
    fill: "url(#a)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0f7a40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.6666667 4.76630728c0-.10762854.0703125-.15972246.1767113-.10652305l.4084821.20424107c.097595.04879748.1767113.17020089.1767113.27795519v1.52556283c0 .10471293-.0815371.18959954-.1922607.18959954h-.3773833c-.1061826 0-.1922607-.08681161-.1922607-.19487872z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.0952381 4.76630728c0-.10762854.0703125-.15972246.1767113-.10652305l.40848215.20424107c.09759496.04879748.17671131.17020089.17671131.27795519v1.52556283c0 .10471293-.08153716.18959954-.19226074.18959954h-.37738329c-.10618267 0-.19226073-.08681161-.19226073-.19487872z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.14285714 5.14198049c0-.10471293.07031254-.22475579.17671132-.27795519l.40848213-.20424107c.09759497-.04879749.17671131-.00154405.17671131.10652305v1.89595686c0 .10762855-.08153714.19487872-.19226072.19487872h-.37738331c-.10618263 0-.19226073-.08184524-.19226073-.18959954z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.61904762 5.90300533c0-.10422697.07031253-.22387587.17671131-.27707527l.40848214-.20424107c.09759497-.04879749.17671131-.00316691.17671131.09626956v.611401l1.14285714-.00000001v.72778332h-.95413752c-.10422697 0-.27025676 0-.38098034 0h-.37738332c-.10618263 0-.19226072-.08967808-.19226072-.18871961z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.57142857 5.90300533c0-.10422697.0703125-.22387587.17671131-.27707527l.40848215-.20424107c.09759495-.04879749.1767113-.00316691.1767113.09626956v.611401l1.14285715-.00000001v.72778332h-.95413754c-.10422696 0-.27025676 0-.38098035 0h-.37738328c-.10618267 0-.19226074-.08967808-.19226074-.18871961z",
    mask: "url(#e)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIq);
export default __webpack_public_path__ + "static/media/IQ.6bc84917d3d5cda2eecc6c27a66b38c2.svg";
export { ForwardRef as ReactComponent };